function getVdmOpt(pmData, that) {
  let xData = pmData.xData;
  let y1Data = pmData.y1Data;
  let y2Data = pmData.y2Data;
  return {
    backgroundColor: "transparent",
    tooltip: {
      show: true,
      trigger: "axis",
      axisPointer: {
        type: "line",
        snap: true,
        lineStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 1,
            y2: 0,
            colorStops: [{
                offset: 0,
                color: "rgba(47,128,237, 0.05)", // 0% 处的颜色
              },
              {
                offset: 0.4,
                color: "rgba(86,204,242, 0.25)", // 0% 处的颜色
              },
              {
                offset: 0.5,
                color: "rgba(86,204,242, 0.45)", // 100% 处的颜色
              },
              {
                offset: 0.5,
                color: "rgba(255, 0, 255, 0)", // 100% 处的颜色
              },
              {
                offset: 1,
                color: "rgba(4, 0, 255, 0)", // 100% 处的颜色
              },
            ],
            global: false, // 缺省为 false
          },
          width: 400,
        },
      },
      backgroundColor: "#000",
      padding: 10,
      textStyle: {
        color: "#fff",
      },
      formatter: function (params) {
        let res;
        if (params) {
          try {
            res = `<span>时间: ${params[0].axisValue}</span></br>`;
            res += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00FFFF;"></span><span>${
                params.seriesName == "小时监测" ? "监测值" : "监测值"
              }: ${
                params[0].value
                  ? params[0].value + (that.unitType ? that.unitType : "")
                  : params[0].value == 0
                  ? 0 + (that.unitType ? that.unitType : "")
                  : "暂无数据"
              }</span></br>`;
          } catch {}
        }
        for (var i = 1; i < params.length; i++) {
          if (params[i]) {
            try {
              if (params[i].value[2].isWarning == 0) {
                // res += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#00FFFF;"></span><span>${params[0].seriesName}: ${params[1].value[1]}</span></br>`;
              } else if (params[i].value[2].isWarning == 1) {
                res = `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FF9537;"></span><span>${
                    params[i].seriesName
                  }</br>&nbsp;&nbsp;&nbsp;&nbsp;发生时间：${
                    params[i].value[2].happenTime
                  }</br>&nbsp;&nbsp;&nbsp;&nbsp;监测值：${
                    params[i].value[2].vdmTdc +
                    (that.unitType ? that.unitType : "")
                  }</span></br>`;
              }
            } catch {}
          }
        }
        return res;
      },
    },
    legend: {
      icon: "circle",
      left: "40%",
      top: "5%",
      data: [{
          name: "小时监测",
          icon: "circle"
        },
        {
          name: "可见烟尘监测 ",
          icon: "circle"
        },
      ],
      formatter: function (name) {
        return name;
      },
      itemWidth: 20,
      itemHeight: 20,
      textStyle: {
        fontSize: 20,
        color: "rgba(255,255,255,0.6)",
        padding: [2, 0, 0, 0],
      },
      selectedMode: false,
    },
    grid: {
      top: "30%",
      left: "6%",
      right: "6%",
      bottom: "6%",
      containLabel: true,
    },
    xAxis: [{
      type: "category",
      axisLine: {
        show: true,
        lineStyle: {
          color: "grey",
          width: 0.1,
        },
      },
      boundaryGap: true,
      axisLabel: {
        textStyle: {
          color: "#b1b6b7",
          fontSize: 20,
          margin: 15,
        },
        formatter(param) {
          let str = "";
          const strArr = param.split('-');
          const month = strArr[1];
          const date = strArr[2].split(" ")[0];
          const hour = strArr[2].split(' ')[1].split(":")[0];
          const minute = strArr[2].split(' ')[1].split(":")[1];
          str = `${month}-${date} ${hour}:${minute}`
          return str
        }
      },
      axisTick: {
        show: false,
      },
      data: xData,
    }, ],
    yAxis: [{
      name: "单位：" + (that.unitType ? that.unitType : "ug/m³"),
      nameTextStyle: {
        fontSize: 20,
        color: "#A6CAFF",
        padding: [0, 0, 0, 20],
      },
      type: "value",
      splitLine: {
        show: true,
        lineStyle: {
          color: "#1E5389",
          width: 1,
        },
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: "#1E5389",
          width: 1,
        },
      },
      axisLabel: {
        margin: 10,
        textStyle: {
          color: "#b1b6b7",
          fontSize: 13,
        },
      },
      axisTick: {
        show: false,
      },
    }, ],
    series: [{
        name: "小时监测",
        type: "line",
        smooth: true,
        symbolSize: 0,
        lineStyle: {
          normal: {
            width: 3,
            color: "#00FFFF",
          },
        },
        itemStyle: {
          normal: {
            color: new echarts.graphic.RadialGradient(
              0.5,
              0.5,
              0.5,
              [{
                  offset: 0,
                  color: "rgba(0, 255, 255, 1)",
                },
                {
                  offset: 0.6,
                  color: "rgba(0, 255, 255, 1)",
                },
                {
                  offset: 0.6,
                  color: "rgba(0, 255, 255, 0.5)",
                },
                {
                  offset: 1,
                  color: "rgba(0, 255, 255, 0.5)",
                },
              ],
              false
            ),
          },
        },
        data: y1Data,
      },
      {
        name: "可见烟尘监测",
        type: "scatter",
        legendHoverLink: true,
        symbolSize: 25,
        itemStyle: {
          color: function (value) {
            if (value.value[2].isWarning == 0) {
              let v = new echarts.graphic.RadialGradient(
                0.5,
                0.5,
                0.5,
                [{
                    offset: 0,
                    color: "rgba(0, 255, 255, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(0, 255, 255, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(0, 255, 255, 0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0, 255, 255, 0.5)",
                  },
                ],
                false
              );
              return v;
            } else {
              let v = new echarts.graphic.RadialGradient(
                0.5,
                0.5,
                0.5,
                [{
                    offset: 0,
                    color: "rgba(255, 149, 55, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(255, 149, 55, 1)",
                  },
                  {
                    offset: 0.6,
                    color: "rgba(255, 149, 55, 0.5)",
                  },
                  {
                    offset: 1,
                    color: "rgba(255, 149, 55, 0.5)",
                  },
                ],
                false
              );
              return v;
            }
          },
        },
        data: y2Data,
      },
      {
        name: "可见烟尘监测 ",
        type: "scatter",
        legendHoverLink: true,
        symbolSize: 25,
        itemStyle: {
          color: new echarts.graphic.RadialGradient(
            0.5,
            0.5,
            0.5,
            [{
                offset: 0,
                color: "rgba(255, 149, 55, 1)",
              },
              {
                offset: 0.6,
                color: "rgba(255, 149, 55, 1)",
              },
              {
                offset: 0.6,
                color: "rgba(255, 149, 55, 0.5)",
              },
              {
                offset: 1,
                color: "rgba(255, 149, 55, 0.5)",
              },
            ],
            false
          ),
        },
        data: [],
      },
    ],
  };
}
export default getVdmOpt